/**
 * Mirror each native Kaching total into its own Concept buy box/sticky price.
 * pricing() supplies formatted money and numeric major units. Never change
 * quantities, selling plans, discounts or the app's cart payload.
 */
(() => {
  'use strict';
  if (window.__c2o3KachingPriceSyncLoaded) return;
  window.__c2o3KachingPriceSyncLoaded = true;

  function sync() {
    document.querySelectorAll('product-info').forEach((info) => {
      const widget = info.querySelector('kaching-bundles-block');
      if (!widget?.querySelector('.kaching-bundles__block--loaded')) return;
      let pricing;
      try { pricing = widget.pricing?.(); } catch { return; }
      const total = pricing?.discountedPrice;
      const full = pricing?.fullPrice;
      if (!total?.formatted || !Number.isFinite(total.amount) || total.amount < 0) return;
      const key = info.dataset.sectionId + '-' + info.dataset.productId;
      const boxes = [info.querySelector('[id^="Price-"]'), document.getElementById('StickyPrice-' + key)];
      boxes.forEach((box) => {
        const regular = box?.querySelector('.price__regular');
        if (!regular) return;
        if (regular.textContent.trim() !== total.formatted) regular.textContent = total.formatted;
        const sale = box.querySelector('.price__sale');
        if (sale) {
          const discounted = Number.isFinite(full?.amount) && full.amount > total.amount;
          if (discounted && sale.textContent.trim() !== full.formatted) sale.textContent = full.formatted;
          if (sale.hidden === discounted) sale.hidden = !discounted;
          regular.closest('.price')?.classList.toggle('price--on-sale', discounted);
        }
      });
    });
  }

  function init() {
    let frame = 0;
    const schedule = () => {
      if (!frame) frame = requestAnimationFrame(() => { frame = 0; sync(); });
    };
    new MutationObserver((records) => {
      if (records.some((record) => {
        const target = record.target.nodeType === Node.ELEMENT_NODE ? record.target : record.target.parentElement;
        return target?.closest('product-info, product-sticky-form') || [...record.addedNodes].some((node) =>
          node.nodeType === Node.ELEMENT_NODE && (node.matches('product-info, product-sticky-form') || node.querySelector('product-info, product-sticky-form'))
        );
      })) schedule();
    }).observe(document.body, { childList: true, characterData: true, subtree: true });
    ['variants-changed', 'items-changed', 'kaching-bundles-block-loaded', 'shopify:section:load'].forEach((name) => {
      document.addEventListener(name, schedule, true);
    });
    sync();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
